import script from "./BrainSearchAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./BrainSearchAdmin.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/objects/BrainSearchAdmin.css?vue&type=style&index=0&id=df8413fc&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df8413fc"]])

export default __exports__